export default __webpack_public_path__ + "static/media/icons8-postgresql.9d07fe8f.svg";